<template>
  <img
    :src="brand.logoSmall.url"
    :class="brand.logoSmall.class"
    :alt="`${brand.name} Logo`"
  />
</template>
